import React, { Component } from 'react';

import Series from 'react/views/series/Series';
import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import ReadALikeFooter from '../../card/ReadALikeFooter';

import './similarSeriesView.less';

class SimilarSeriesView extends Component {
    renderSimilarSeries() {
        const similarSeries = this.props.cardModel.map((series, index) => {
            const isLastItem = (index + 1) === this.props.cardModel.length;
            return <Series key={series.title}
                authorName={series.authorName}
                title={series.title}
                reasonText={series.reasonText}
                bookJacketUrl={series.bookJacketUrl}
                isLastItem={isLastItem}
                onClick={() => { this.props.onItemClick(series.uniqueId) }} />
        });
        return similarSeries;
    }

    render() {
        return (
            <Card>
                <CardTitle title="Similar Series" />
                <div className="similar-series-view-content">
                    {this.renderSimilarSeries()}
                </div>
				<ReadALikeFooter onNext={this.props.onNext} onPrevious={this.props.onPrevious} />
            </Card>
        );
    }
}

export default SimilarSeriesView;



// WEBPACK FOOTER //
// ./src/react/views/similarSeries/SimilarSeriesView.jsx